import _ from 'lodash';
import PropTypes from 'prop-types';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import { PARTNER_NAME } from 'v3/common/utils/types.type';

const propTypes = {
  orderType: PropTypes.string.isRequired,
};

const defaultProps = {};

const RunFormInstructions = ({ orderType }) => {
  const oneIndentation = ' ';

  const getText = () => {
    switch (ApplicationDomainUtility.partnerName) {
      case PARTNER_NAME.ALGOVERSE:
      case PARTNER_NAME.QUBIT:
        return `You need to login daily before market opens for the Automatic order/s to be successfully placed.`;
      default:
        return `${oneIndentation}
      You need to login into ${ApplicationDomainUtility.partnerName} daily before market starts for the
      ${oneIndentation}
      ${_.startCase(orderType)}
      ${oneIndentation}
      order to be successfully placed with your broker.`;
    }
  };

  return (
    <div className="alert alert-sm alert-info mb-2 mt-2">
      <strong>Information : </strong>
      {getText()}
    </div>
  );
};

RunFormInstructions.propTypes = propTypes;
RunFormInstructions.defaultProps = defaultProps;

export default RunFormInstructions;
